import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from './assets/logo.svg'
import _imports_1 from './assets/activeloop.png'
import _imports_2 from './assets/towardsailogo.png'
import _imports_3 from './assets/intel.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"margin":"auto","margin-left":"10px"} }, "AI Tutor", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "my-2 text-center" }, "Brought to you in collaboration with Activeloop, Towards AI, & Intel Disruptor Initiative ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_main_component = _resolveComponent("main-component")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        app: "",
        elevation: 0,
        density: "compact"
      }, {
        append: _withCtx(() => []),
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh())),
                variant: "text",
                class: "px-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: _imports_0,
                    width: "25px",
                    height: "25px",
                    style: {"margin":"5px"}
                  }),
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_main_component),
          _createVNode(_component_v_footer, {
            class: "justify-center",
            color: "#00111a"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { class: "w-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        height: "40px",
                        width: "100px",
                        src: _imports_1
                      }),
                      _createVNode(_component_v_img, {
                        height: "40px",
                        width: "100px",
                        src: _imports_2
                      }),
                      _createVNode(_component_v_img, {
                        height: "40px",
                        width: "100px",
                        src: _imports_3
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}